export class CareerAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Every opening of a country, newest first. */
    list(country) {
        return this.client.request({ method: 'GET', path: `/v1/admin/career-openings?country=${encodeURIComponent(country)}`, auth: true });
    }
    /** Create a DRAFT. */
    create(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/career-openings', body: input, auth: true });
    }
    /** Replace the words of a DRAFT or OPEN opening (`CAREER_OPENING_CLOSED` when it is closed). */
    edit(openingId, content) {
        return this.client.request({ method: 'PUT', path: `/v1/admin/career-openings/${encodeURIComponent(openingId)}`, body: content, auth: true });
    }
    /** Open it on the site, close it, or bring it back to a draft. */
    setStatus(openingId, status) {
        return this.client.request({ method: 'POST', path: `/v1/admin/career-openings/${encodeURIComponent(openingId)}/status`, body: { status }, auth: true });
    }
}
export class CareerPublicApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The OPEN openings of a country (public, no session), newest `openedAt` first. */
    list(country) {
        return this.client.request({ method: 'GET', path: `/v1/public/career-openings?country=${encodeURIComponent(country)}`, auth: false });
    }
}
//# sourceMappingURL=careers.js.map